<script>
export default {
  name: 'NoResults',
};
</script>

<template lang="pug">
div.no-results.white.tc
  icon.w3.mv4.center.db.fill-white.o-20(name="no-results")
  h4.fw7.ttu.f6.mb3 {{ $t('No results') }}
  h6.f7
    slot
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
.no-results {

}
</style>
